import type { ReactNode } from "react"
import { cn } from "../utils/cn"

export function Island({
  children,
  className,
}: { children: ReactNode; className?: string }): ReactNode {
  return (
    <div className={cn("bg-[#3A3A3A] p-5 border-2 border-[#2E2E2E]", className)}>
      {children}
    </div>
  )
}
